module.exports = __webpack_public_path__ + "img/error.8cab1085.svg";